import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { FieldWrapper, FieldLabelWrapper } from './css';
import Note from '../../note';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';

const FieldRadio = ({ data }) => {
  const {
    name,
    label,
    options,
    required,
    onChange,
    note,
    readonly,
    tooltip,
    tooltipLong,
    toolTipRichText,
    noteAppearsBelowField = false,
    value: fieldValue
  } = data;

  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;
  return (
    <FieldWrapper>
      {note && !noteAppearsBelowField && note.content && (
        <Note type="richText" data={note} />
      )}
      <FieldLabelWrapper>
        <FieldTitle required={required} label={label} />
        {tooltipMessage && (
          <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
        )}
      </FieldLabelWrapper>
      <div
        id="fieldRadio"
        style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}
      >
        {options.map(item => {
          const {
            fields: { label: itemLabel, value, disabled }
          } = item;
          const id = `${name}${itemLabel}`;

          return (
            <Fragment key={id}>
              <input
                type="radio"
                id={id}
                name={name}
                checked={value === fieldValue}
                value={value}
                onChange={onChange}
                disabled={disabled || readonly}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-for */}
              <label htmlFor={id}>{itemLabel}</label>
            </Fragment>
          );
        })}
      </div>
      {note && noteAppearsBelowField && note.content && (
        <Note type="richText" data={note} />
      )}
    </FieldWrapper>
  );
};

FieldRadio.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.arrayOf(PropTypes.object),
    readonly: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          value: PropTypes.string.isRequired
        })
      })
    ).isRequired,
    noteAppearsBelowField: PropTypes.bool
  }).isRequired
};

export default FieldRadio;
